export const INSPECTION_REPORT_SUBMIT_ERROR_FALLBACK = 'Something went wrong saving the report.';

const MUTATION_ERROR_FALLBACK = 'Failed to update report';

/** Extract user-facing message from axios-style errors (mutation + catch). */
export function getAxiosErrorMessage(err: unknown, fallback: string = INSPECTION_REPORT_SUBMIT_ERROR_FALLBACK): string {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: { errors?: string[]; error?: string; message?: string } } }).response
      ?.data;
    return data?.errors?.[0] ?? data?.error ?? data?.message ?? fallback;
  }
  return fallback;
}

/** Message for React Query mutation error object when no local submitError is set. */
export function getInspectionReportMutationDisplayError(error: unknown): string | null {
  if (!error) return null;
  return getAxiosErrorMessage(error, MUTATION_ERROR_FALLBACK);
}
